import { get, writable } from 'svelte/store'
import { Object3D } from 'three'
import { storeScene } from './scene'
import { restoreOriginalMaterial } from '../helpers/selection-material'

export const canvasSelection = writable<Object3D | undefined>()

export const setCanvasSelection = (value: Object3D) =>
  canvasSelection.set(value)

// Items added on top of `canvasSelection` via ctrl/cmd+click. `canvasSelection`
// itself stays the single "primary" item so every pre-existing consumer of that
// store keeps working unchanged; this store is purely additive.
export const canvasMultiSelection = writable<Object3D[]>([])

export const removeFromMultiSelection = (uuid: string) => {
  const current = get(canvasMultiSelection)
  const match = current.find(object => object.uuid === uuid)
  if (!match) return

  restoreOriginalMaterial(match)
  canvasMultiSelection.set(current.filter(object => object.uuid !== uuid))
}

// Safety net for mutations that remove objects from the scene without knowing
// about this store: drops any selected item that no longer exists.
export const pruneMissingFromMultiSelection = () => {
  const scene = get(storeScene)
  const current = get(canvasMultiSelection)
  const stale = current.filter(object => !scene?.getObjectByProperty('uuid', object.uuid))

  if (!stale.length) return

  stale.forEach(restoreOriginalMaterial)
  canvasMultiSelection.set(current.filter(object => scene?.getObjectByProperty('uuid', object.uuid)))
}
